module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-thank-you",
    class: {
      'is-donation': _vm.isDonation
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.thankYouText))]), _vm._v(" "), (_vm.isDonation) ? _c('div', {
    staticClass: "lr-ty-donation"
  }, [_c('p', [_c('span', {
    staticClass: "in-focus"
  }, [_vm._v(_vm._s(_vm.supporter.firstName) + " " + _vm._s(_vm.supporter.lastName))]), _vm._v(", thank you for your donation of\n      "), _c('span', {
    staticClass: "in-focus"
  }, [_vm._v("$ " + _vm._s(_vm.donation.amount))])]), _vm._v(" "), _c('p', {
    staticClass: "minimal"
  }, [_vm._v("\n      Please check your email for confirmation. If you don’t receive an email,\n      please note that due to the high volume of donations we’ve received, it\n      may take longer than normal for us to process your payment receipt.\n    ")]), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ls-ty-share"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.getSocialText) + "\n    ")])]), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "minimal"
  }, [_vm._v("\n      For urgent questions, please call our supporter relations team on\n      "), _c('a', {
    attrs: {
      "href": "tel:1800032551"
    }
  }, [_vm._v("1800 032 551")]), _vm._v(".\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gs-wrapper"
  }, [_c('div', {
    staticClass: "getsocial gs-inline-group"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0047f2ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!./~/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./src/components/leaf-relief/ThankYou.vue
// module id = 607
// module chunks = 0